(() => {
  const init = () => {
    document.querySelectorAll('.z128-gallery').forEach((gallery) => {
      if (gallery.dataset.z128LightboxReady === 'true') return;
      const modal = gallery.querySelector('[data-z128-lightbox]');
      const stage = gallery.querySelector('[data-z128-stage-image]');
      const count = gallery.querySelector('[data-z128-count]');
      const triggers = Array.from(gallery.querySelectorAll('.z128-lightbox-trigger'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-z128-thumb]'));
      if (!modal || !stage || !triggers.length) return;

      gallery.dataset.z128LightboxReady = 'true';
      let index = 0;
      let returnFocus = null;

      const setActive = (nextIndex) => {
        index = (Number(nextIndex) + triggers.length) % triggers.length;
        const item = triggers[index];
        stage.src = item.dataset.z128Full || item.href;
        stage.alt = item.dataset.z128Alt || '';
        if (count) count.textContent = `${index + 1} / ${triggers.length}`;
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        const activeThumb = thumbs[index];
        if (activeThumb) activeThumb.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
      };

      const open = (nextIndex, source) => {
        returnFocus = source || document.activeElement;
        setActive(nextIndex);
        modal.hidden = false;
        modal.setAttribute('aria-hidden','false');
        document.documentElement.classList.add('z128-lightbox-open');
        const close = modal.querySelector('[data-z128-close].z128-lightbox__close');
        if (close) close.focus({preventScroll:true});
      };

      const close = () => {
        modal.hidden = true;
        modal.setAttribute('aria-hidden','true');
        document.documentElement.classList.remove('z128-lightbox-open');
        stage.removeAttribute('src');
        if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus({preventScroll:true});
      };

      triggers.forEach((trigger, i) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          open(i, trigger);
        });
      });

      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => setActive(i)));
      modal.querySelectorAll('[data-z128-close]').forEach((el) => el.addEventListener('click', close));
      const prev = modal.querySelector('[data-z128-prev]');
      const next = modal.querySelector('[data-z128-next]');
      if (prev) prev.addEventListener('click', () => setActive(index - 1));
      if (next) next.addEventListener('click', () => setActive(index + 1));

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
        if (event.key === 'ArrowLeft') setActive(index - 1);
        if (event.key === 'ArrowRight') setActive(index + 1);
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ZYPHER_V166_SUPPORT_ACCORDION_EXCLUSIVE
   Only one product-support detail can remain open at a time. */
(() => {
  const bindSupportAccordions = () => {
    document.querySelectorAll('.z128-support-grid').forEach((grid) => {
      if (grid.dataset.z128ExclusiveReady === 'true') return;
      grid.dataset.z128ExclusiveReady = 'true';

      const items = Array.from(grid.querySelectorAll('details.z128-support-item'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSupportAccordions);
  } else {
    bindSupportAccordions();
  }
  document.addEventListener('shopify:section:load', bindSupportAccordions);
})();


/* ZYPHER_V245_DIRECT_HERO_VIDEO_PLAYER
   External hero videos bypass Shopify's flaky deferred poster path.
   We inject the exact player before setActiveMedia(), autoplay it muted,
   and only advance after the real video ends. */
(() => {
  let youtubeApiPromise = null;

  const loadYouTubeApi = () => {
    if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
    if (youtubeApiPromise) return youtubeApiPromise;

    youtubeApiPromise = new Promise((resolve) => {
      const check = () => {
        if (window.YT && window.YT.Player) return resolve(window.YT);
        window.setTimeout(check, 75);
      };
      if (!document.querySelector('script[data-zypher-youtube-api]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.dataset.zypherYoutubeApi = 'true';
        document.head.appendChild(script);
      }
      check();
    });
    return youtubeApiPromise;
  };

  const bind = () => {
    document.querySelectorAll('[data-z167-media-carousel]').forEach((carousel) => {
      if (carousel.dataset.z245Ready === 'true') return;
      carousel.dataset.z245Ready = 'true';

      const strip = carousel.querySelector('[data-z167-media-strip]');
      const prev = carousel.querySelector('[data-z167-media-prev]');
      const next = carousel.querySelector('[data-z167-media-next]');
      const thumbs = Array.from(carousel.querySelectorAll('[data-z167-media-target]'));
      const gallery = carousel.closest('media-gallery');
      if (!strip || !gallery || !thumbs.length) return;

      let index = Math.max(0, thumbs.findIndex((t) => t.classList.contains('is-active')));
      let timer = null;
      let generation = 0;
      let paused = false;
      let userControlled = false;
      let visible = true;
      const imageMs = 4600;
      const heroStage = gallery.querySelector(':scope > .slider-mobile-gutter:not(.thumbnail-slider)');
      let activeStageThumb = null;
      let activeStageSlide = null;
      let activeStageType = 'image';
      let programmaticMediaTarget = null;
      let programmaticMediaTimer = null;

      const stopTimer = () => {
        if (timer) window.clearTimeout(timer);
        timer = null;
      };

      /* ZYPHER V248: autoplay is only for untouched galleries.
         The instant a customer swipes, taps a thumbnail, or uses an arrow,
         hand control to them and never yank the gallery to the next timer slide. */
      const handControlToUser = () => {
        if (userControlled) return;
        userControlled = true;
        paused = true;
        generation += 1;
        stopTimer();
      };

      const centerThumb = (thumb, behavior='smooth') => {
        const maxLeft = Math.max(0, strip.scrollWidth - strip.clientWidth);
        const left = Math.max(0, Math.min(maxLeft, thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2));
        strip.scrollTo({left, behavior});
      };

      const advance = (token) => {
        if (token !== generation || userControlled) return;
        if (paused || !visible || document.hidden) {
          timer = window.setTimeout(() => advance(token), 400);
          return;
        }
        select(index + 1);
      };

      const scheduleImage = (token) => {
        stopTimer();
        if (userControlled) return;
        timer = window.setTimeout(() => advance(token), imageMs);
      };

      const findSlide = (thumb) => {
        const target = thumb?.dataset?.z167MediaTarget;
        return target ? gallery.querySelector('[data-media-id="' + CSS.escape(target) + '"]') : null;
      };

      /* ZYPHER V249 ACTIVE MEDIA FIT
         The cover can keep its natural portrait stage. Screenshots and videos
         get a stage matching THEIR aspect ratio so a 16:9 image never sits at
         the top of a tall cover-sized box with hundreds of pixels of dead space. */
      const mediaRatio = (thumb, slide, mediaType) => {
        if (mediaType === 'video' || mediaType === 'external_video') return 16 / 9;

        const image =
          slide?.querySelector('.product__media img') ||
          slide?.querySelector('img') ||
          thumb?.querySelector('img');

        if (!image) return 16 / 9;

        const width =
          image.naturalWidth ||
          Number(image.getAttribute('width')) ||
          Number(thumb?.querySelector('img')?.getAttribute('width')) ||
          16;
        const height =
          image.naturalHeight ||
          Number(image.getAttribute('height')) ||
          Number(thumb?.querySelector('img')?.getAttribute('height')) ||
          9;

        return Math.min(2.4, Math.max(0.45, width / Math.max(1, height)));
      };

      const fitActiveStage = (thumb, slide, mediaType) => {
        activeStageThumb = thumb || null;
        activeStageSlide = slide || null;
        activeStageType = mediaType || 'image';

        if (!heroStage || !thumb) return;

        /* The uploaded cover is intentionally portrait and already has its
           own tuned sizing rules. Only alternate media uses the adaptive box. */
        if (thumb.classList.contains('z167-steam-media__thumb--cover')) {
          gallery.classList.remove('z249-active-media-fit');
          gallery.style.removeProperty('--z249-active-stage-height');
          return;
        }

        const ratio = mediaRatio(thumb, slide, mediaType);
        const width = Math.max(
          1,
          heroStage.getBoundingClientRect().width ||
          heroStage.clientWidth ||
          gallery.getBoundingClientRect().width
        );

        let height = Math.round(width / ratio);
        const minHeight = window.innerWidth < 750 ? 180 : 240;
        const maxHeight = window.innerWidth < 750 ? 560 : 600;
        height = Math.max(minHeight, Math.min(maxHeight, height));

        gallery.style.setProperty('--z249-active-stage-height', height + 'px');
        gallery.classList.add('z249-active-media-fit');
      };

      let z249FitResizeTimer = null;
      window.addEventListener('resize', () => {
        if (!gallery.classList.contains('z249-active-media-fit')) return;
        window.clearTimeout(z249FitResizeTimer);
        z249FitResizeTimer = window.setTimeout(() => {
          fitActiveStage(activeStageThumb, activeStageSlide, activeStageType);
        }, 80);
      }, {passive:true});

      const sizeHeroVideo = (iframe, container) => {
        if (!iframe || !container) return;
        const box = container.getBoundingClientRect();
        const W = Math.max(1, box.width);
        const H = Math.max(1, box.height);
        const ratio = 16 / 9;

        let w = W;
        let h = w / ratio;
        if (h > H) {
          h = H;
          w = h * ratio;
        }

        iframe.style.setProperty('position','absolute','important');
        iframe.style.setProperty('left','50%','important');
        iframe.style.setProperty('top','50%','important');
        iframe.style.setProperty('right','auto','important');
        iframe.style.setProperty('bottom','auto','important');
        iframe.style.setProperty('transform','translate(-50%, -50%)','important');
        iframe.style.setProperty('width', Math.floor(w) + 'px','important');
        iframe.style.setProperty('height', Math.floor(h) + 'px','important');
        iframe.style.setProperty('min-width','0','important');
        iframe.style.setProperty('min-height','0','important');
        iframe.style.setProperty('max-width','100%','important');
        iframe.style.setProperty('max-height','100%','important');
        iframe.style.setProperty('margin','0','important');
      };

      const buildExternalFrame = (thumb, slide) => {
        if (!slide) return null;
        const host = thumb.dataset.z167VideoHost || '';
        const videoId = thumb.dataset.z167VideoId || '';
        if (!videoId) return null;

        const container = slide.querySelector('deferred-media') || slide;
        let iframe = container.querySelector('iframe[data-z245-hero-video="true"]');

        if (!iframe) {
          // Prevent Shopify from later cloning a second deferred iframe.
          if (container.matches?.('deferred-media')) container.setAttribute('loaded','true');
          const poster = container.querySelector('.deferred-media__poster');
          if (poster) {
            poster.hidden = true;
            poster.style.display = 'none';
          }

          iframe = document.createElement('iframe');
          iframe.dataset.z245HeroVideo = 'true';
          iframe.className = host === 'youtube' ? 'js-youtube z245-hero-video' : 'js-vimeo z245-hero-video';
          iframe.title = thumb.getAttribute('aria-label') || 'Game video';
          iframe.loading = 'eager';
          iframe.allowFullscreen = true;
          iframe.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');

          if (host === 'youtube') {
            iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) +
              '?autoplay=1&mute=1&playsinline=1&rel=0&enablejsapi=1&controls=1';
          } else if (host === 'vimeo') {
            iframe.src = 'https://player.vimeo.com/video/' + encodeURIComponent(videoId) +
              '?autoplay=1&muted=1&playsinline=1&controls=1&api=1';
          } else {
            return null;
          }

          container.appendChild(iframe);
        }

        sizeHeroVideo(iframe, container);
        window.requestAnimationFrame(() => sizeHeroVideo(iframe, container));
        return iframe;
      };

      const playYouTube = async (iframe, token) => {
        if (!iframe || token !== generation) return;
        iframe.__zypherGeneration = token;

        try {
          const YT = await loadYouTubeApi();
          if (token !== generation) return;

          if (iframe.__zypherPlayer) {
            try { iframe.__zypherPlayer.mute(); } catch(e) {}
            try { iframe.__zypherPlayer.playVideo(); } catch(e) {}
            return;
          }

          iframe.__zypherPlayer = new YT.Player(iframe, {
            events:{
              onReady(event){
                if (iframe.__zypherGeneration !== generation) return;
                try { event.target.mute(); } catch(e) {}
                try { event.target.playVideo(); } catch(e) {}
              },
              onStateChange(event){
                if (iframe.__zypherGeneration !== generation) return;
                if (event.data === YT.PlayerState.ENDED) {
                  advance(iframe.__zypherGeneration);
                }
              }
            }
          });
        } catch(e) {}
      };

      const playVimeo = (iframe, token) => {
        if (!iframe || token !== generation) return;
        iframe.__zypherGeneration = token;
        try {
          iframe.contentWindow?.postMessage({method:'setVolume',value:0}, '*');
          iframe.contentWindow?.postMessage({method:'play'}, '*');
        } catch(e) {}
        // Do not apply the image timer to Vimeo. If the provider does not
        // expose a reliable ended event here, the customer/manual navigation wins.
      };

      const playNativeVideo = (slide, token, attempt=0) => {
        if (token !== generation) return true;
        const video = slide?.querySelector('video');
        if (video) {
          video.muted = true;
          video.defaultMuted = true;
          video.loop = false;
          video.playsInline = true;
          video.__zypherGeneration = token;
          video.onended = () => {
            if (video.__zypherGeneration === generation) advance(video.__zypherGeneration);
          };
          const p = video.play?.();
          if (p?.catch) p.catch(()=>{});
          return true;
        }

        const deferred = slide?.querySelector('deferred-media');
        if (deferred && attempt === 0) {
          try { deferred.loadContent(false); } catch(e) {}
        }
        if (deferred && attempt < 30) {
          window.setTimeout(() => playNativeVideo(slide, token, attempt + 1), 100);
          return true;
        }
        return false;
      };

      function select(nextIndex, behavior='smooth'){
        stopTimer();
        generation += 1;
        const token = generation;
        index = (nextIndex + thumbs.length) % thumbs.length;
        const active = thumbs[index];
        const mediaType = active.dataset.z167MediaType || 'image';
        const slide = findSlide(active);

        thumbs.forEach((thumb,i) => {
          const yes = i === index;
          thumb.classList.toggle('is-active', yes);
          if (yes) thumb.setAttribute('aria-current','true');
          else thumb.removeAttribute('aria-current');
        });

        // Prepare external video BEFORE Shopify activates the slide so its
        // deferred loader sees "loaded" and cannot leave the poster behind.
        let externalFrame = null;
        if (mediaType === 'external_video') {
          externalFrame = buildExternalFrame(active, slide);
        }

        const target = active.dataset.z167MediaTarget;
        if (target && typeof gallery.setActiveMedia === 'function') {
          /* Mark our own carousel movement so the slideChanged listener below
             can distinguish autoplay/button changes from a real customer swipe. */
          programmaticMediaTarget = target;
          window.clearTimeout(programmaticMediaTimer);
          programmaticMediaTimer = window.setTimeout(() => {
            programmaticMediaTarget = null;
          }, 500);
          gallery.setActiveMedia(target, false);
        }

        fitActiveStage(active, slide, mediaType);
        centerThumb(active, behavior);

        if (mediaType === 'external_video' && externalFrame) {
          const host = active.dataset.z167VideoHost || '';
          window.setTimeout(() => {
            if (host === 'youtube') playYouTube(externalFrame, token);
            else playVimeo(externalFrame, token);
          }, 80);
          return;
        }

        if (mediaType === 'video') {
          window.setTimeout(() => {
            if (!playNativeVideo(slide, token)) scheduleImage(token);
          }, 100);
          return;
        }

        scheduleImage(token);
      }

      thumbs.forEach((thumb,i) => thumb.addEventListener('click', () => {
        handControlToUser();
        select(i);
      }));
      prev?.addEventListener('click', () => {
        handControlToUser();
        select(index - 1);
      });
      next?.addEventListener('click', () => {
        handControlToUser();
        select(index + 1);
      });

      gallery.addEventListener('mouseenter', () => { paused = true; });
      gallery.addEventListener('mouseleave', () => { if (!userControlled) paused = false; });
      gallery.addEventListener('focusin', () => { paused = true; });
      gallery.addEventListener('focusout', () => { if (!userControlled) paused = false; });

      /* Any touch/pen interaction means the customer is browsing manually.
         Do not resume autoplay after touchend. */
      gallery.addEventListener('touchstart', handControlToUser, {passive:true});
      gallery.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.pointerType === 'pen') handControlToUser();
      }, {passive:true});
      strip.addEventListener('wheel', handControlToUser, {passive:true});

      /* ZYPHER V250 MANUAL SWIPE STAGE SYNC
         Dawn's native mobile gallery fires slideChanged when a customer swipes
         the main image. Keep our Steam rail + active-stage height synchronized
         with that manually selected media too, not only with autoplay/clicks. */
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      viewer?.addEventListener('slideChanged', (event) => {
        const slide = event.detail?.currentElement;
        const mediaId = slide?.dataset?.mediaId;
        if (!slide || !mediaId) return;

        const manualIndex = thumbs.findIndex((thumb) => thumb.dataset.z167MediaTarget === mediaId);
        if (manualIndex < 0) return;

        const thumb = thumbs[manualIndex];
        const mediaType = thumb.dataset.z167MediaType || 'image';
        const wasProgrammatic = programmaticMediaTarget === mediaId;

        if (wasProgrammatic) {
          programmaticMediaTarget = null;
          window.clearTimeout(programmaticMediaTimer);
        } else {
          handControlToUser();
          index = manualIndex;

          thumbs.forEach((item, i) => {
            const yes = i === manualIndex;
            item.classList.toggle('is-active', yes);
            if (yes) item.setAttribute('aria-current', 'true');
            else item.removeAttribute('aria-current');
          });

          centerThumb(thumb, 'smooth');
        }

        /* This is the piece that was missing: a manual swipe now recalculates
           the hero height exactly like an automatic carousel change. */
        fitActiveStage(thumb, slide, mediaType);
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          visible = entries[0]?.isIntersecting !== false;
        }, {threshold:.15});
        observer.observe(gallery);
      }

      if (window.matchMedia && window.matchMedia('(max-width:749px)').matches) {
        window.setTimeout(() => select(index, 'auto'), 900);
      } else {
        select(index, 'auto');
      }
    });
  };

  const muteNativeAutoplay = (root=document) => {
    root.querySelectorAll('video[autoplay]').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
    });
  };

  const resizeDirectHeroVideos = () => {
    document.querySelectorAll('iframe[data-z245-hero-video="true"]').forEach((iframe) => {
      const container = iframe.closest('deferred-media') || iframe.parentElement;
      if (!container) return;
      const box = container.getBoundingClientRect();
      const W = Math.max(1, box.width);
      const H = Math.max(1, box.height);
      const ratio = 16 / 9;
      let w = W;
      let h = w / ratio;
      if (h > H) {
        h = H;
        w = h * ratio;
      }
      iframe.style.setProperty('left','50%','important');
      iframe.style.setProperty('top','50%','important');
      iframe.style.setProperty('transform','translate(-50%, -50%)','important');
      iframe.style.setProperty('width', Math.floor(w) + 'px','important');
      iframe.style.setProperty('height', Math.floor(h) + 'px','important');
    });
  };

  let z245ResizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(z245ResizeTimer);
    z245ResizeTimer = window.setTimeout(resizeDirectHeroVideos, 80);
  });

  const init = () => { muteNativeAutoplay(document); bind(); window.setTimeout(resizeDirectHeroVideos, 120); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (event) => {
    muteNativeAutoplay(event.target || document);
    bind();
  });

  const z246ObserverRoot = document.querySelector('main') || document.body;
  if (z246ObserverRoot) {
    let z246MutationQueued = false;
    let z246AddedNodes = [];

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) z246AddedNodes.push(node);
        });
      });

      if (z246MutationQueued) return;
      z246MutationQueued = true;

      window.requestAnimationFrame(() => {
        z246MutationQueued = false;
        const nodes = z246AddedNodes.splice(0, z246AddedNodes.length);
        nodes.forEach((node) => muteNativeAutoplay(node));
      });
    }).observe(z246ObserverRoot,{subtree:true,childList:true});
  }
})();


/* ZYPHER_V174_ASPECT_AWARE_HERO
   Each game gets a top layout based on its uploaded cover-art shape.
   Keep the full cover contained within a compact stage, while the purchase
   card uses its natural content height independently of the selected media. */
(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const bindAdaptiveHero = () => {
    document.querySelectorAll('body.template-product [id^="MainProduct-"]').forEach((main) => {
      if (main.dataset.z174AdaptiveBound === 'true') return;
      main.dataset.z174AdaptiveBound = 'true';

      const product = main.querySelector('.product');
      const gallery = main.querySelector('media-gallery.z167-game-gallery') || main.querySelector('media-gallery');
      const mediaWrapper = main.querySelector('.product__media-wrapper');
      const infoWrapper = main.querySelector('.product__info-wrapper');
      if (!product || !gallery || !mediaWrapper || !infoWrapper) return;

      let resizeTimer;

      const recalc = () => {
        // Clear legacy equal-height state before measuring real purchase content.
        infoWrapper.style.removeProperty('--z174-info-min-height');
        infoWrapper.classList.remove('z174-symmetric-info');
        if (window.innerWidth < 990) {
          product.style.removeProperty('--z170-media-column');
          product.style.removeProperty('--z170-info-column');
          gallery.style.removeProperty('--z172-stage-height');
          gallery.style.removeProperty('--z174-rail-height');
          return;
        }

        const coverItem = gallery.querySelector('.product__media-item:first-child');
        const image = coverItem?.querySelector('img') || gallery.querySelector('.product__media-item img');
        if (!image) return;

        const apply = () => {
          if (window.innerWidth < 990) return;
          const naturalWidth = image.naturalWidth || Number(image.getAttribute('width')) || 1;
          const naturalHeight = image.naturalHeight || Number(image.getAttribute('height')) || 1;
          const ratio = clamp(naturalWidth / naturalHeight, 0.50, 1.75);

          const rail = gallery.querySelector('.z167-steam-media');
          const railHeight = rail ? Math.ceil(rail.getBoundingClientRect().height || 82) : 0;
          const railGap = railHeight ? 8 : 0;

          /* Platform/art-shape families get different ideal widths.
             This is intentionally ratio-driven rather than hard-coded by console. */
          let desiredMediaWidth;
          if (ratio < 0.80) {
            desiredMediaWidth = 470;   // tall DVD-style covers
          } else if (ratio < 0.98) {
            desiredMediaWidth = 510;   // slightly taller than square
          } else if (ratio < 1.22) {
            desiredMediaWidth = 565;   // SNES / squarer artwork
          } else {
            desiredMediaWidth = 610;   // landscape artwork/screens
          }

          /* Height required to show the ENTIRE uploaded cover at that width. */
          let coverStageHeight = desiredMediaWidth / ratio;

          if (ratio < 0.80) {
            coverStageHeight = clamp(coverStageHeight, 575, 655);
          } else if (ratio < 0.98) {
            coverStageHeight = clamp(coverStageHeight, 525, 620);
          } else if (ratio < 1.22) {
            coverStageHeight = clamp(coverStageHeight, 455, 555);
          } else {
            coverStageHeight = clamp(coverStageHeight, 420, 510);
          }

          /* Media column should be exactly large enough for the full cover,
             not an arbitrary giant box. */
          const mediaColumn = clamp(coverStageHeight * ratio, 420, 610);

          /* Keep the right side roomy and readable while staying inside the
             shared 1180px product canvas. */
          const canvasWidth = Math.min(1180, Math.max(980, product.parentElement?.clientWidth || 1180));
          const gap = 16;
          const availableInfo = canvasWidth - mediaColumn - gap;
          const textLoad = (infoWrapper.innerText || '').length;
          const preferredInfo = clamp(480 + Math.min(65, textLoad / 34), 480, 550);
          const infoColumn = clamp(Math.min(preferredInfo, availableInfo), 455, 550);

          product.style.setProperty('--z170-media-column', mediaColumn.toFixed(0) + 'px');
          product.style.setProperty('--z170-info-column', infoColumn.toFixed(0) + 'px');

          /* Bound the original-cover stage by the actual purchase content.
             Containment keeps the whole cover visible without stretching either
             column; selected screenshots retain their separate V249 aspect fit. */
          const infoNaturalHeight = Math.ceil(infoWrapper.scrollHeight || infoWrapper.getBoundingClientRect().height || 470);
          const stageCap = clamp(infoNaturalHeight - railHeight - railGap, 360, 560);
          const stageHeight = Math.min(coverStageHeight, stageCap);

          gallery.style.setProperty('--z172-stage-height', Math.round(stageHeight) + 'px');
          gallery.style.setProperty('--z174-rail-height', Math.round(railHeight) + 'px');
          gallery.style.setProperty('--z170-hero-width', '100%');

          gallery.classList.toggle('z174-cover-tall', ratio < 0.80);
          gallery.classList.toggle('z174-cover-standard', ratio >= 0.80 && ratio < 0.98);
          gallery.classList.toggle('z174-cover-square', ratio >= 0.98 && ratio < 1.22);
          gallery.classList.toggle('z174-cover-wide', ratio >= 1.22);
        };

        if (image.complete && image.naturalWidth) apply();
        else image.addEventListener('load', apply, { once:true });
      };

      const schedule = () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(recalc, 70);
      };

      /* Only recalc for real geometry changes. Hero autoplay no longer causes
         the page to resize because we always measure the original cover art. */
      window.addEventListener('resize', schedule, { passive:true });
      document.addEventListener('variant:change', schedule);
      document.addEventListener('shopify:section:load', schedule);

      const rail = gallery.querySelector('.z167-steam-media');
      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(schedule);
        if (rail) ro.observe(rail);
        ro.observe(infoWrapper);
      }

      recalc();
      window.setTimeout(recalc, 250);
      window.setTimeout(recalc, 900);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAdaptiveHero);
  } else {
    bindAdaptiveHero();
  }
  document.addEventListener('shopify:section:load', bindAdaptiveHero);
})();


/* ZYPHER_V171_MEDIA_RAIL_CONTROLS
   Full-width Screenshots & Media rail controls. */
(() => {
  const bind = () => {
    document.querySelectorAll('.z171-media-browser').forEach((browser) => {
      if (browser.dataset.z171Ready === 'true') return;
      browser.dataset.z171Ready = 'true';

      const rail = browser.querySelector('[data-z171-media-rail]');
      const prev = browser.querySelector('[data-z171-media-prev]');
      const next = browser.querySelector('[data-z171-media-next]');
      if (!rail) return;

      const move = (direction) => {
        const amount = Math.max(260, Math.round(rail.clientWidth * 0.72));
        rail.scrollBy({ left: amount * direction, behavior:'smooth' });
      };

      prev?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();


/* ZYPHER_V173_DYNAMIC_VARIANT_QUICK_SPECS
   Keep Quick Specs synchronized with the exact variant selected above.
   State of Item, stock status, SKU and barcode now follow variant changes. */
(() => {
  const updateQuickSpecs = (variant) => {
    if (!variant) return;

    document.querySelectorAll('[data-z173-quick-specs]').forEach((specs) => {
      const availability = specs.querySelector('[data-z173-availability]');
      const condition = specs.querySelector('[data-z173-condition]');
      const sku = specs.querySelector('[data-z173-sku]');
      const barcode = specs.querySelector('[data-z173-barcode]');

      const rawIndex = Number.parseInt(specs.dataset.z173ConditionIndex || '-1', 10);
      let conditionValue = '';

      if (Array.isArray(variant.options)) {
        if (rawIndex >= 0 && rawIndex < variant.options.length) {
          conditionValue = variant.options[rawIndex] || '';
        } else if (variant.options.length === 1) {
          conditionValue = variant.options[0] || '';
        }
      }

      if (!conditionValue && variant.title && variant.title !== 'Default Title') {
        conditionValue = variant.title;
      }

      if (availability) {
        availability.textContent = variant.available ? 'In stock' : 'Out of stock';
        availability.dataset.stock = variant.available ? 'in' : 'out';
      }

      if (condition) {
        condition.textContent = conditionValue || '—';
        const row = condition.closest('[data-z173-condition-row]');
        if (row) {
          const blank = !conditionValue;
          row.hidden = blank;
          row.classList.toggle('z227-spec-empty', blank);
        }
      }

      if (sku) {
        sku.textContent = variant.sku || '—';
        const row = sku.closest('[data-z173-sku-row]');
        if (row) {
          const blank = !variant.sku;
          row.hidden = blank;
          row.classList.toggle('z227-spec-empty', blank);
        }
      }

      if (barcode) {
        barcode.textContent = variant.barcode || '—';
        const row = barcode.closest('[data-z173-barcode-row]');
        if (row) {
          const blank = !variant.barcode;
          row.hidden = blank;
          row.classList.toggle('z227-spec-empty', blank);
        }
      }

      /* ZYPHER_V234_DYNAMIC_ROW_VISIBILITY */
    });
  };

  const bind = () => {
    if (window.__zypherV173QuickSpecsBound) return;
    window.__zypherV173QuickSpecsBound = true;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        updateQuickSpecs(event?.data?.variant);
      });
    }

    /* Fallback for any theme interaction that changes a variant before the
       pub/sub render finishes. The canonical variant event above remains the
       source of truth once Shopify resolves the selected option combination. */
    document.addEventListener('change', (event) => {
      const picker = event.target?.closest?.('variant-radios, variant-selects');
      if (!picker) return;

      window.setTimeout(() => {
        try {
          const variantDataNode = picker.querySelector('[type="application/json"]');
          if (!variantDataNode) return;
          const variants = JSON.parse(variantDataNode.textContent || '[]');

          const selected = Array.from(picker.querySelectorAll('.product-form__input')).map((wrapper) => {
            const checked = wrapper.querySelector('input:checked');
            if (checked) return checked.value;
            const select = wrapper.querySelector('select');
            return select ? select.value : null;
          }).filter((value) => value !== null);

          const match = variants.find((variant) =>
            Array.isArray(variant.options) &&
            selected.length === variant.options.length &&
            variant.options.every((value, index) => value === selected[index])
          );

          if (match) updateQuickSpecs(match);
        } catch (error) {}
      }, 30);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();


/* ZYPHER_V227_HIDE_EMPTY_QUICK_SPECS
   Hide Quick Specs rows until they have a real value. This keeps sparse
   products clean while allowing enriched data / variant data to appear
   automatically as soon as it exists. */
(() => {
  const isBlankSpecValue = (value) => {
    const normalized = String(value || '')
      .replace(/\u00a0/g, ' ')
      .trim()
      .toLowerCase();

    return normalized === '' ||
      normalized === '—' ||
      normalized === '–' ||
      normalized === '-';
  };

  const refreshQuickSpecVisibility = (root = document) => {
    root.querySelectorAll('[data-z173-quick-specs]').forEach((specs) => {
      /* ZYPHER_V234_QUICK_SPEC_ROW_SELECTOR_FIX */
      specs.querySelectorAll('.z176-spec-grid > div').forEach((row) => {
        if (!(row instanceof HTMLElement)) return;

        /* Rows use their bold/value node as the source of truth. If a
           future field uses another value element, fall back to the last
           non-label child instead of hiding the whole grid incorrectly. */
        const valueNode =
          row.querySelector('b') ||
          row.querySelector('[data-z173-availability], [data-z173-condition], [data-z173-sku], [data-z173-barcode]') ||
          row.lastElementChild;

        if (!valueNode) return;

        const blank = isBlankSpecValue(valueNode.textContent);
        /* ZYPHER_V238_FORCE_HIDE_EMPTY_SPEC_CELLS
           Some later grid CSS uses display:grid !important, which can beat
           the browser's native [hidden] rule. Set display:none !important
           for empty cells so placeholder rows cannot remain visible. */
        row.classList.toggle('z227-spec-empty', blank);
        row.hidden = blank;
        if (blank) {
          row.style.setProperty('display', 'none', 'important');
        } else {
          row.style.removeProperty('display');
        }
        row.setAttribute('aria-hidden', blank ? 'true' : 'false');
      });
    });
  };

  const scheduleRefresh = () => {
    window.requestAnimationFrame(() => refreshQuickSpecVisibility(document));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once:true });
  } else {
    scheduleRefresh();
  }

  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('variant:change', scheduleRefresh);

  if (typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      window.setTimeout(scheduleRefresh, 0);
    });
  }

  /* Variant updates can rewrite SKU/barcode/availability after the initial
     render. Observe only Quick Specs blocks and re-evaluate changed rows. */
  const bindObservers = () => {
    document.querySelectorAll('[data-z173-quick-specs]').forEach((specs) => {
      if (specs.dataset.z227Observed === 'true') return;
      specs.dataset.z227Observed = 'true';

      const observer = new MutationObserver(() => refreshQuickSpecVisibility(specs.parentElement || document));
      observer.observe(specs, {
        subtree:true,
        childList:true,
        characterData:true
      });
    });
  };

  const bindAndRefresh = () => {
    bindObservers();
    refreshQuickSpecVisibility(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAndRefresh, { once:true });
  } else {
    bindAndRefresh();
  }

  document.addEventListener('shopify:section:load', bindAndRefresh);
})();


/* ZYPHER_V237_CENTER_SHORT_MEDIA_RAILS
   Center product thumbnails only when all items fit inside the available
   rail. Re-check after images load, resizing, section reloads and mutations. */
(() => {
  const selectors = [
    '.z167-steam-media__viewport',
    '.z171-media-rail'
  ];

  const measureRail = (rail) => {
    if (!(rail instanceof HTMLElement)) return;

    const children = Array.from(rail.children).filter((node) => node instanceof HTMLElement);
    if (!children.length) {
      rail.classList.remove('z237-media-fits');
      return;
    }

    const style = window.getComputedStyle(rail);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;

    let contentWidth = 0;
    children.forEach((child, index) => {
      const rect = child.getBoundingClientRect();
      const childStyle = window.getComputedStyle(child);
      const marginLeft = parseFloat(childStyle.marginLeft || '0') || 0;
      const marginRight = parseFloat(childStyle.marginRight || '0') || 0;
      contentWidth += rect.width + marginLeft + marginRight;
      if (index < children.length - 1) contentWidth += gap;
    });

    const fits = contentWidth <= rail.clientWidth + 1;
    rail.classList.toggle('z237-media-fits', fits);

    if (fits && rail.scrollLeft !== 0) {
      rail.scrollLeft = 0;
    }
  };

  const refresh = (root = document) => {
    selectors.forEach((selector) => {
      root.querySelectorAll(selector).forEach(measureRail);
    });
  };

  let resizeTimer;
  const schedule = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      window.requestAnimationFrame(() => refresh(document));
    }, 40);
  };

  const bind = (root = document) => {
    refresh(root);

    selectors.forEach((selector) => {
      root.querySelectorAll(selector).forEach((rail) => {
        if (rail.dataset.z237Observed === 'true') return;
        rail.dataset.z237Observed = 'true';

        rail.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', schedule, { once:true });
        });

        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(schedule);
          ro.observe(rail);
        }

        const mo = new MutationObserver(schedule);
        mo.observe(rail, { childList:true, subtree:true });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bind(document), { once:true });
  } else {
    bind(document);
  }

  window.addEventListener('resize', schedule, { passive:true });
  document.addEventListener('shopify:section:load', (event) => bind(event.target || document));
})();

(function () {
  function activateShelfVideos(root) {
    var templates = Array.from(root.querySelectorAll('template[data-z-seo-video]'));
    if (!templates.length) return;
    function mount(template) {
      template.replaceWith(template.content.cloneNode(true));
    }
    if (!('IntersectionObserver' in window)) {
      templates.forEach(mount);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('template[data-z-seo-video]').forEach(mount);
        observer.unobserve(entry.target);
      });
    }, {rootMargin: '250px 0px'});
    templates.forEach(function (template) {
      observer.observe(template.parentElement);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { activateShelfVideos(document); });
  } else {
    activateShelfVideos(document);
  }
  document.addEventListener('shopify:section:load', function (event) { activateShelfVideos(event.target); });
})();
